import { WebServices } from "./WebServices.js";

const SYNC_TTL_MS = 5 * 60 * 1000;

let offset = 0;
let syncedAt = 0;
let pending = null;

async function sync() {
  const started = Date.now();
  const timestamp = Number(await WebServices.getServerTimestamp());
  if (!Number.isFinite(timestamp) || timestamp <= 0) throw new Error('invalid_server_timestamp');
  const finished = Date.now();
  // El servidor respondió en algún punto del viaje de ida y vuelta; el punto medio es la mejor
  // estimación de en qué instante local se emitió esa marca de tiempo.
  offset = Math.round(timestamp - (started + finished) / 2);
  syncedAt = finished;
}

/**
 * Deja el desfase al día si ya venció, y luego resuelve.
 *
 * Una sincronización fallida no es fatal: el desfase se queda donde estaba, que en el primer
 * intento significa cero, es decir, el reloj del propio dispositivo. Nunca rechaza, así que quien
 * la llame no necesita una rama de error.
 *
 * @returns {Promise<void>}
 */
export async function syncServerClock() {
  if (Date.now() - syncedAt <= SYNC_TTL_MS) return;
  pending = pending || sync()
    .catch((error) => {
      console.warn(`An error occurred while syncing the server clock: ${error}`);
    })
    .finally(() => {
      pending = null;
    });
  await pending;
}

/**
 * Cuánto se aleja el reloj del dispositivo del reloj del servidor, en milisegundos.
 *
 * Es síncrono, para que lo que se dibuja en cada tick pueda corregirse sin esperar. Vale cero
 * hasta que llegue la primera sincronización, que también es la respuesta honesta para un
 * dispositivo que nunca ha logrado hablar con el servidor.
 *
 * @returns {number}
 */
export const serverOffset = () => offset;

/**
 * Hora del servidor según el desfase conocido hasta ahora.
 *
 * @returns {Date}
 */
export const serverNow = () => new Date(Date.now() + offset);
